export const ETH_SEND_TRANSACTION = 'eth.sendTransaction()'
export const ETH_SIGN = 'eth.sign()'
export const PERSONAL_SIGN = 'personal.sign()'
export const BOX_GET_PROFILE = 'box.getProfile()'
export const DAI_BALANCE_OF = 'dai.balanceOf()'
export const DAI_TRANSFER = 'dai.transfer()'
